import { styled, css } from 'next-yak'

import * as colors from '../constants/colors'
import * as glyphs from '../icons/glyphs'

export const statusGlyph = {
  failed: glyphs.stroke.TimesCircle,
  pending: glyphs.stroke.Clock,
  succeeded: glyphs.stroke.CheckCircle,
  waiting: glyphs.stroke.Ellipse,
}

type IconPastilleProps = {
  $status: 'failed' | 'pending' | 'succeeded' | 'waiting'
  $withBackground: boolean
}

export const IconPastille = styled.div<IconPastilleProps>`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: 32px;
  justify-content: center;
  margin-right: 8px;
  width: 32px;

  ${({ $status, $withBackground }) => {
    if ($status === 'failed') {
      if ($withBackground) {
        return css`
          background-color: ${colors.SECONDARY_RED_200};
          color: ${colors.PRIMARY_RED_700};
        `
      } else {
        return css`
          color: ${colors.PRIMARY_RED_700};
        `
      }
    }
    if ($status === 'waiting') {
      if ($withBackground) {
        return css`
          background-color: ${colors.PRIMARY_SAND_100};
        `
      }
    }
    if ($status === 'succeeded') {
      if ($withBackground) {
        return css`
          background-color: ${colors.BACKGROUND_SUCCESS};
          color: ${colors.SECONDARY_GREEN_500};
        `
      } else {
        return css`
          color: ${colors.SECONDARY_GREEN_500};
        `
      }
    }
    if ($status === 'pending') {
      if ($withBackground) {
        return css`
          background-color: ${colors.BACKGROUND_ALERT};
          color: ${colors.SECONDARY_YELLOW_500};
        `
      } else {
        return css`
          color: ${colors.SECONDARY_YELLOW_500};
        `
      }
    }
  }}
`
